import other from "./other";
import staff from "./staff";

// ==============================|| MENU ITEMS ||============================== //

const role = localStorage.getItem("role");

const menuItems = {
  items: [role === "Admin" ? other : role === "Staff" ? staff : other],
};

export default menuItems;
